import React, { PureComponent } from "react";
import { string, func, object } from "prop-types";
import TrackVisibility from "react-on-screen";

class LazyLoadImage extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            inViewport: false,
            loaded: false
        };

        this.loadImage = this.loadImage.bind(this);
        this.imageLoaded = this.imageLoaded.bind(this);
        this.onEnter = this.onEnter.bind(this);
        this.renderImage = this.renderImage.bind(this);
    }

    loadImage() {
        const { loaded } = this.state;

        if (!loaded) {
            this.lazyLoadImage = new Image();
            this.lazyLoadImage.onload = this.imageLoaded();
            this.lazyLoadImage.src = this.props.src;
        }
    }

    imageLoaded() {
        this.setState({ loaded: true });
    }

    onEnter() {
        this.loadImage();
    }

    renderImage() {
        if (this.state.loaded) {
            return (
                <img
                    src={this.props.src}
                    alt={this.props.alt}
                    className={this.props.className}
                    style={this.props.style}
                    title={this.props.title}
                    onError={this.props.onError}
                />
            );
        }
    }

    render() {
        if (!this.props.src) return null;

        return (
            <React.Fragment>
                <TrackVisibility offset={1000} once>
                    {({ isVisible }) => isVisible && this.onEnter()}
                </TrackVisibility>
                {this.renderImage()}
            </React.Fragment>
        );
    }
}

LazyLoadImage.defaultProps = {
    src: "/images/image-not-found.png",
    onError: (e) => {
        e.target.src = "/images/image-not-found.png";
    },
    className: "",
    alt: ""
};

LazyLoadImage.propTypes = {
    src: string.isRequired,
    onError: func,
    alt: string,
    className: string,
    title: string,
    style: object
};

export default LazyLoadImage;